<div class="password">
  <rs-web-form-field controlErrorContainer>
    <input
      [type]="showPasswordAsText() ? 'text' : 'password'"
      [formControl]="passwordControl.control"
      [placeholder]="
        (isConfirmPassword() ? 'pw_set_form.password_repeat_l' : 'general.password') | translate
      "
      class="form-control primary-text"
    />
  </rs-web-form-field>
  <span class="password__eye">
    @if (showPasswordAsText()) {
      <rs-web-icon
        [icon]="ImmomioIconName.EyeOpen"
        (tapped)="showPasswordAsText.set(false)"
      ></rs-web-icon>
    } @else {
      <rs-web-icon
        [icon]="ImmomioIconName.EyeClosed"
        (tapped)="showPasswordAsText.set(true)"
      ></rs-web-icon>
    }
  </span>

  @if (!this.hideValidatorBox()) {
    <rs-web-card [elevation]="1" class="mt-3 requirement-box">
      <div class="requirement-box-title">
        <rs-web-icon [icon]="ImmomioIconName.LockClosed"></rs-web-icon>
        <p class="pl15">
          {{ 'password.required.info_l' | translate }}
        </p>
      </div>
      <ul>
        @for (validatorContext of validatorContexts; track validatorContext.name) {
          <li>
            {{ validatorContext.text | translate }}
          </li>
        }
      </ul>
    </rs-web-card>
  }
</div>
